import React, { useRef, useState } from 'react';
import * as S from './CategoryBadge.styled';
import { createPortal } from 'react-dom';
import { WP_REST_API_Tags } from 'wp-types';

interface Props {
  tagList?: string[];
  variant?: 'primary' | 'secondary';
  maxCategories?: number;
  tags?: WP_REST_API_Tags;
}

export const CategoryBadge: React.FC<Props> = ({
  tagList = [],
  variant = 'secondary',
  maxCategories = 99
}) => {
  const visibleSubcategories = tagList.slice(0, Math.max(0, maxCategories));
  const remainingSubcategories = tagList.slice(visibleSubcategories.length);

  const [showPopover, setShowPopover] = useState(false);
  const [popoverPos, setPopoverPos] = useState<{ left: number; top: number }>({
    left: 0,
    top: 0
  });
  const moreRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    if (moreRef.current) {
      const rect = moreRef.current.getBoundingClientRect();
      setPopoverPos({
        left: rect.left,
        top: rect.bottom + 4
      });
      setShowPopover(true);
    }
  };

  return (
    <S.StyledBadges>
      {visibleSubcategories.map((category) => (
        <S.StyledBadge key={category} variant={variant}>
          {category}
        </S.StyledBadge>
      ))}
      {remainingSubcategories.length > 0 && (
        <S.StyledBadge
          ref={moreRef}
          variant={variant}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={() => setShowPopover(false)}
          style={{ position: 'relative', cursor: 'pointer' }}
        >
          ...
          {showPopover &&
            createPortal(
              <S.Popover
                style={{
                  position: 'fixed',
                  left: popoverPos.left,
                  top: popoverPos.top,
                  zIndex: 9999
                }}
              >
                {remainingSubcategories.map((cat) => (
                  <div key={cat}>{cat}</div>
                ))}
              </S.Popover>,
              document.body
            )}
        </S.StyledBadge>
      )}
    </S.StyledBadges>
  );
};
